import { useNavigate } from "react-router-dom";

const principles = [
  { icon: "ri-magic-line", title: "内容真实", desc: "只收录真实、可读、画风在线的古风国漫，拒绝搬运与凑数，让每一部作品都值得被看到。" },
  { icon: "ri-focus-3-line", title: "分类清晰", desc: "古言、宫斗、权谋、武侠、仙侠、江湖六大题材清晰划分，帮助你快速直达想看的作品。" },
  { icon: "ri-calendar-check-line", title: "更新及时", desc: "热门作品每日更新，第一时间汇总上新章节，追更不再错过。" },
  { icon: "ri-user-heart-line", title: "读者为先", desc: "从读者体验出发打磨页面与功能，让阅读更顺畅、收藏更轻松。" },
];

const testimonials = [
  { name: "青柠同学", role: "古言爱好者", text: "分类真的太友好了！想找宫斗漫画，直接点进去全是心头好，画风也都在线。" },
  { name: "山间清风", role: "武侠迷", text: "追《剑起江湖远》就是在这看到的，更新很及时，收藏功能帮我记着每一话。" },
  { name: "落笔惊鸿", role: "仙侠读者", text: "专题文章写得很有深度，看完对题材的理解都不一样了，真的很用心。" },
];

export default function About() {
  const navigate = useNavigate();
  return (
    <div>
      <section className="relative w-full overflow-hidden">
        <div className="relative h-48 w-full md:h-60">
          <img
            src="https://readdy.ai/api/search-image?query=%E5%8F%A4%E4%BB%A3%E5%8F%B0%E6%A1%88%E6%AF%9B%E7%AC%94%E5%AE%A3%E7%BA%B8%E4%B8%8E%E5%B1%B1%E6%B0%B4%E5%B7%A5%E5%85%B7%E6%9A%97%E9%87%91%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E8%83%8C%E6%99%AF%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=1600&height=440&seq=about-banner-2026&orientation=landscape"
            alt="古风漫画网关于我们横幅"
            className="absolute inset-0 h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 to-foreground-950/30"></div>
          <div className="relative z-10 container-x flex h-full flex-col justify-center">
            <nav className="flex items-center gap-1.5 text-sm text-background-300" aria-label="面包屑">
              <button onClick={() => navigate("/")} className="cursor-pointer hover:text-background-50">首页</button>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-accent-300">关于我们</span>
            </nav>
            <h1 className="mt-2 font-heading text-3xl font-bold text-background-50 md:text-4xl">关于古风漫画网</h1>
            <p className="mt-1.5 text-sm text-background-200">为每一位古风漫画爱好者守护一方故事天地</p>
          </div>
        </div>
      </section>

      {/* 品牌介绍 */}
      <section className="container-x py-14">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
              <span className="h-px w-6 bg-primary-500"></span>品牌介绍
            </p>
            <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">一家专注古风国漫的在线阅读站</h2>
            <div className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-700">
              <p>古风漫画网成立于网文改编国漫快速崛起的时代，我们相信，每一部用心创作的古风漫画，都值得被认真对待、被更多人看见。</p>
              <p>我们聚焦古言、宫斗、权谋、武侠、仙侠、江湖六大题材，聚合最受欢迎的古风国漫，用清晰的分层与及时的更新，为漫迷打造一座随时可抵达的故事驿站。</p>
              <p>无论你是初入古风世界的新读者，还是阅片无数的老漫迷，这里都有一部适合你的作品，在某个深夜，为你点亮一盏灯。</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              { num: "200+", label: "收录作品" },
              { num: "6", label: "大题材分类" },
              { num: "1000+", label: "更新章节" },
              { num: "50万+", label: "追更读者" },
            ].map((s) => (
              <div key={s.label} className="rounded-lg border border-background-300/60 bg-background-100 p-6 text-center">
                <p className="font-heading text-3xl font-bold text-primary-600">{s.num}</p>
                <p className="mt-1 text-sm text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 理念 */}
      <section className="w-full bg-background-100 py-14">
        <div className="container-x">
          <p className="flex items-center justify-center gap-2 text-sm font-semibold text-primary-600">
            <span className="h-px w-6 bg-primary-500"></span>发展理念
          </p>
          <h2 className="mt-1 text-center font-heading text-2xl font-bold text-foreground-950 md:text-3xl">把古风故事，讲给更多人听</h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-sm text-foreground-600">
            我们坚持内容为本、读者为先，用精细的运营与用心的体验，让古风国漫走进更多人的生活。
          </p>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {principles.map((p) => (
              <div key={p.title} className="rounded-lg border border-background-300/60 bg-background-50 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 用户口碑 */}
      <section className="container-x py-14">
        <p className="flex items-center justify-center gap-2 text-sm font-semibold text-primary-600">
          <span className="h-px w-6 bg-primary-500"></span>用户口碑
        </p>
        <h2 className="mt-1 text-center font-heading text-2xl font-bold text-foreground-950 md:text-3xl">来自读者的声音</h2>
        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="rounded-lg border border-background-300/60 bg-background-100 p-6">
              <div className="flex gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 text-secondary-900">
                  <i className="ri-user-line"></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* 联系方式 */}
      <section className="container-x pb-14">
        <div className="flex flex-col items-center justify-between gap-5 rounded-lg bg-secondary-950 px-8 py-10 text-center sm:flex-row sm:text-left">
          <div>
            <h2 className="font-heading text-2xl font-bold text-background-50">想与我们合作或反馈建议？</h2>
            <p className="mt-2 text-sm text-background-300">无论是作品投稿、版权合作还是使用建议，都欢迎随时联系我们。</p>
          </div>
          <button onClick={() => navigate("/contact")} className="btn-primary shrink-0">
            <i className="ri-chat-3-line mr-1.5"></i>联系我们
          </button>
        </div>
      </section>
    </div>
  );
}